import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import Mask from "vanilla-masker";
import { FaRegQuestionCircle } from "react-icons/fa";

import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  Alert,
  AlertColor,
  AlertTitle,
  ButtonBase,
  Switch,
  Checkbox,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import ReactSelect from "react-select";
import { Search } from "@mui/icons-material";
import OrderInterface from "../interfaces/OrderInterface";
import moment from "moment";
import API_FARE from "../services/apiFare";
import FareInterface from "../interfaces/FareInterface";
import UserBusinessInterface from "../interfaces/UserBusinessInterface";
import AuthService from "../services/auth.service";
import NotyfContext from "../contexts/NotyfContext";
import AppContext from "../contexts/AppContext";
import UserService from "../services/user.service";
import BusinessFareInterface from "../interfaces/BusinessFareInterface";
import BusinessFareEstimateParametersInterface from "../interfaces/BusinessFareEstimateParametersInterface";
import functionsApiPublic from "../services/apiPublic.service";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { red } from "@mui/material/colors";

export interface ICoverageAreaByBusiness {
  _id: string;
  businessID: string;
  coverageAreaID: string;
  coverageArea: {
    id: string;
    name: string;
  };
  enabled: boolean;
  price: number;
  vehicleCategory: number;
}

function getSteps() {
  return ["Itinerário", "Forma de transporte e entrega"];
}

const CreateOrderByCoverageArea = () => {
  const [favorities, setFavorities] = useState<any[]>([]);
  const [neighborhood, setNeighborhood] = React.useState<string>("");
  const [number, setNumber] = React.useState<string>("");
  const [complement, setComplement] = React.useState<string>("");
  const [zipcode, setZipcode] = React.useState<string>("");
  const [destination, setDestination] = React.useState<any>("");
  const [destinations, setDestinations] = React.useState<
    ICoverageAreaByBusiness[]
  >([]);
  const [exclusiveDelivery, setExclusiveDelivery] =
    React.useState<boolean>(false);

  const [directDelivery, setDirectDelivery] = React.useState<boolean>(false);

  // const [motoboys, setMotoboys] = React.useState<any[]>([]);
  const [motoboy, setMotoboy] = React.useState<string>("");
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    functionsApiPublic
      .getFavorities()
      .then(({ data }) => {
        setFavorities(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getCEP = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `https://viacep.com.br/ws/${zipcode}/json/`
      );
      setNeighborhood(data.logradouro);
    } catch (error) {
      console.error(error);
    }
  }, [zipcode]);

  const selectedDestination = useMemo(
    () => destinations?.find((d) => d.coverageAreaID === destination),
    [destinations, destination]
  );

  const options = useMemo(() => {
    return destinations.map((destination) => ({
      value: destination.coverageAreaID,
      label: `${destination.coverageArea?.name} - ${Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(destination.price)}`,
    }));
  }, [destinations]);

  const handleChange = (event: any) => {
    if (!!event?.value) {
      setDestination(event.value as string);
    }
  };

  const handleChangeMotoboy = (event: any) => {
    if (!!event?.value) {
      setMotoboy(event.value as string);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "56px", // Altura do input
    }),
    // Estilo para o container do menu
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#fff",
      zIndex: 9999, // Cor de fundo desejada
    }),
    // Estilo para as opções do menu
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#FF3432" : "#ffffff", // Cor de fundo das opções selecionadas e não selecionadas
      color: state.isSelected ? "#ffffff" : "#000000", // Cor do texto das opções selecionadas e não selecionadas
      "&:hover": {
        backgroundColor: "#FF3432", // Cor de fundo ao passar o mouse sobre as opções
        color: "#ffffff", // Cor do texto ao passar o mouse sobre as opções
      },
    }),
  };

  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return (
          <>
            <Box
              style={{
                padding: 16,
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={8} md={8} xs={12}>
                  <Grid container spacing={2}>
                    {user?.address?.formatted_address === "" ||
                    user?.address?.formatted_address === undefined ? (
                      <>
                        <Grid item lg={12} md={12} xs={12}>
                          <Alert severity={"info"}>
                            <AlertTitle>Aviso! Perfil incompleto.</AlertTitle>
                            Vá para o perfil e complete o cadastro. Insira o
                            endereço de origem padrão. Em caso de dúvidas,
                            contate o suporte do Leve Aí - Parceiros.
                          </Alert>
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                    <Grid mb={4} item lg={8} md={8} xs={12}>
                      <Typography fontWeight={"bold"}>
                        Endereço de origem:
                      </Typography>

                      <Typography>
                        {newOrder?.originAddress?.formatted_address}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid mt={4} item lg={12} md={12} xs={12}>
                    <Typography fontWeight={"bold"}>
                      Endereço de destino:
                    </Typography>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid mt={4} item lg={8} md={8} xs={12}>
                      <FormControl fullWidth>
                        <ReactSelect
                          styles={customStyles}
                          className="basic-single"
                          // defaultValue={""}
                          // isLoading={false}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={options}
                          placeholder={"Selecione o bairro de destino"}
                          noOptionsMessage={() => "Nenhum bairro encontrado."}
                          onChange={handleChange}
                        />
                        {/* <Select
                          labelId="destination-label"
                          id="destination"
                          value={destination}
                          label="Selecione o bairro de destino"
                          onChange={handleChange}
                        >
                          {destinations.map((destination) => (
                            <MenuItem
                              key={destination._id}
                              value={destination.coverageAreaID}
                            >
                              {destination.coverageArea?.name} -{" "}
                              {Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(destination.price)}
                            </MenuItem>
                          ))}
                        </Select> */}
                      </FormControl>
                    </Grid>
                    <Grid mt={4} item lg={4} md={4} xs={12}>
                      <div style={{ display: "flex", gap: 4 }}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            type="text"
                            variant="outlined"
                            autoComplete={"off"}
                            label={"CEP"}
                            value={zipcode}
                            placeholder={"12345-678"}
                            onChange={(event) =>
                              setZipcode(
                                Mask.toPattern(event.target.value, "99999-999")
                              )
                            }
                          />
                        </FormControl>
                        <ButtonBase
                          onClick={getCEP}
                          style={{
                            backgroundColor: "#FF3333",
                            width: 64,
                            borderRadius: 8,
                          }}
                        >
                          <Search style={{ color: "#fff" }} />
                        </ButtonBase>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid mt={4} item lg={8} md={8} xs={12}>
                      <FormControl fullWidth>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          autoComplete={"off"}
                          label={"Logradouro"}
                          value={neighborhood}
                          placeholder={"Rua Leopoldina Silva"}
                          onChange={(event) =>
                            setNeighborhood(event.target.value)
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid mt={4} item lg={4} md={3} xs={12}>
                      <FormControl fullWidth>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          autoComplete={"off"}
                          label={"Número"}
                          placeholder={"200"}
                          onChange={(event) => setNumber(event.target.value)}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid mt={4} item lg={12} md={12} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        autoComplete={"off"}
                        rows={2}
                        multiline
                        label={"Complemento"}
                        placeholder={"Na praça por trás da igreja"}
                        onChange={(event) => setComplement(event.target.value)}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </>
        );
      case 1:
        return (
          <>
            <Box
              style={{
                padding: 16,
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Nome do destinatário"
                    type="text"
                    variant="outlined"
                    placeholder="Digite o nome do destinatário"
                    autoComplete={"off"}
                    value={newOrder.recipientName}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Destinatário");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        recipientName: event.target.value,
                      }));
                    }}
                    required
                    error={
                      newOrder.recipientName === "" ||
                      newOrder.recipientName === undefined
                    }
                    helperText={
                      newOrder.recipientName === "" ||
                      newOrder.recipientName === undefined
                        ? "Preencha o nome do destinatário."
                        : ""
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Telefone do destinatário"
                    type="text"
                    variant="outlined"
                    placeholder="Digite o nome do destinatário"
                    autoComplete={"off"}
                    value={newOrder.recipientPhone}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Destinatário");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        recipientPhone: event.target.value,
                      }));
                    }}
                    required
                    error={
                      newOrder.recipientPhone === "" ||
                      newOrder.recipientPhone === undefined
                    }
                    helperText={
                      newOrder.recipientPhone === "" ||
                      newOrder.recipientPhone === undefined
                        ? "Preencha o telefone do destinatário."
                        : ""
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="outlined"
                    placeholder="Digite a observação"
                    autoComplete={"off"}
                    value={newOrder.packDescription}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Observações");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        packDescription: event.target.value,
                      }));
                    }}
                  />
                </Grid>

                <Grid item lg={4} md={6} xs={12}>
                  <Card elevation={4}>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 16,
                        backgroundColor: "#DDD",
                      }}
                    >
                      <Typography>Pagamento</Typography>
                      <FaRegQuestionCircle
                        style={{ cursor: "pointer" }}
                        onClick={handleClickOpen}
                      />
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">
                          {"Quais são as taxas e repasses?"}
                        </DialogTitle>
                        <DialogContent sx={{ width: 500 }}>
                          <DialogContentText id="alert-dialog-description">
                            Nesta entrega de{" "}
                            {Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(selectedDestination?.price ?? 6.25)}
                            <br />
                            <br />
                            {Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(
                              (selectedDestination?.price ?? 6.25) * 0.8
                            )}{" "}
                            será repassado integralmente ao entregador
                            <br />
                            {Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(
                              (selectedDestination?.price ?? 6.25) * 0.2
                            )}{" "}
                            taxa administrativa (tecnologia, seguro de vida das
                            entregas e custo de repasse financeiro)
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose} autoFocus>
                            Fechar
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Box>
                    <CardContent>
                      <Box>
                        {businessFare?.vehicleCategories !== undefined && (
                          <Typography>
                            O preço sugerido pelo serviço é de{" "}
                            {Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(
                              businessFare?.vehicleCategories[0]?.sharedPrice ??
                                5
                            )}
                            .
                          </Typography>
                        )}

                        <TextField
                          fullWidth
                          label={"Valor efetivo (R$)*"}
                          variant={"outlined"}
                          defaultValue={
                            selectedDestination?.price !== undefined
                              ? selectedDestination?.price.toFixed(2)
                              : 7.25
                          }
                          type={"number"}
                          // onChange={(event) => {
                          //   // console.log(event.target.value);
                          //   // console.log("Preço custom");
                          //   setNewOrder((prevState) => ({
                          //     ...prevState,
                          //     price: parseFloat(event.target.value) ?? 0.0,
                          //   }));
                          // }}
                          error={newOrder.price < originalPrice}
                          helperText={"Esse é o valor efetivo a ser pago."}
                          style={{
                            marginTop: 16,
                            marginBottom: 16,
                          }}
                          disabled={true}
                        />
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Forma de pagamento
                          </FormLabel>
                          <RadioGroup
                            aria-label="Forma de pagamento"
                            name="paymentMethod"
                            value={newOrder.paymentMethod}
                            onChange={(event) => {
                              // console.log("Forma de pagamento");
                              setNewOrder((prevState) => ({
                                ...prevState,
                                paymentMethod: event.target.value,
                              }));
                            }}
                          >
                            <FormControlLabel
                              value={"CASH"}
                              control={<Radio />}
                              label={"Saldo pré-pago"}
                              key={"CASH"}
                              disabled={false}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={6}
                  xs={12}
                  sx={{
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      borderWidth: 1,
                      borderColor: "grey",
                      borderRadius: 1,
                      boxShadow: 2,
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingInline: 16,
                        paddingBlock: 8,
                        backgroundColor: "#DDD",
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                      }}
                    >
                      <Typography>Entrega direcionada</Typography>
                      <Switch
                        value={directDelivery}
                        onChange={(e) => setDirectDelivery(e.target.checked)}
                      />
                    </Box>
                    <Box
                      sx={{
                        padding: 2,
                        border: "1px solid #DDD",
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        paddingBottom: 6,
                        paddingTop: 4,
                      }}
                    >
                      <FormControl component="fieldset" sx={{ width: "100%" }}>
                        <FormLabel component="legend" sx={{ marginBottom: 2 }}>
                          Selecione o motoboy para realizar sua entrega
                        </FormLabel>
                        <ReactSelect
                          styles={customStyles}
                          className="basic-single"
                          isDisabled={!directDelivery}
                          // defaultValue={""}
                          // isLoading={false}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={favorities.map((motoboy) => ({
                            value: motoboy._id,
                            label: motoboy.name,
                          }))}
                          placeholder={""}
                          noOptionsMessage={() => "Nenhum motoboy encontrado."}
                          onChange={handleChangeMotoboy}
                        />
                      </FormControl>
                      {directDelivery && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "initial",
                            marginTop: 2,
                          }}
                        >
                          <Checkbox
                            defaultChecked={!exclusiveDelivery}
                            onChange={(e) =>
                              setExclusiveDelivery(!e.target.checked)
                            }
                            sx={{
                              color: red[500],
                              "&.Mui-checked": {
                                color: red[500],
                              },
                            }}
                          />
                          {/* <Switch
                              value={exclusiveDelivery}
                              onChange={(e) =>
                                setExclusiveDelivery(e.target.checked)
                              }
                            /> */}
                          <span>
                            Buscar entregadores disponíveis para entrega caso o
                            entregador escolhido não esteja disponível.
                          </span>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        );
      default:
        return "Unknown step";
    }
  }
  const history = useNavigate();
  const notyf = useContext(NotyfContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const appContext = useContext(AppContext);
  const currentUser = AuthService.getCurrentUser();
  const [user, setUser] = useState<UserBusinessInterface>();

  useEffect(() => {
    if (!!user?._id) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL_API_V2}/api/business/coverage-areas/${user._id}`
        )
        .then(({ data }) => {
          const arr = data
            .filter((d: ICoverageAreaByBusiness) => d.enabled)
            .filter((d: ICoverageAreaByBusiness) => !!d.coverageAreaID)
            .filter((d: ICoverageAreaByBusiness) => !!d.coverageArea?.name);

          const countMap = {};
          arr.forEach((item) => {
            const name = item.coverageArea?.name?.toLowerCase();
            countMap[name] = (countMap[name] || 0) + 1;
          });

          const duplicatedItems = Object.entries(countMap)
            .filter(([, value]) => Number(value) > 1)
            .map(([key]) => key);

          setDestinations(
            arr.map((item) =>
              duplicatedItems.includes(item?.coverageArea?.name.toLowerCase())
                ? {
                    ...item,
                    coverageArea: {
                      ...item.coverageArea,
                      name: `${item?.coverageArea?.name} (${item?.coverageArea?.city?.name})`,
                    },
                  }
                : item
            )
          );
        });
    }
  }, [user?._id]);

  useEffect(() => {
    if (user?.address !== null && user?.address !== undefined) {
      setNewOrder((prevState) => ({
        ...prevState,
        originAddress: {
          formatted_address: user.address?.formatted_address ?? "-/-",
          addressLine2: user.address?.addressLine2 ?? "-/-",
        },
        originCoordinate: {
          type: "Point",
          coordinates: [
            user.address?.coordinates[0] ?? 0,
            user.address?.coordinates[1] ?? 0,
          ],
        },
      }));
      setOrigin(user.address.formatted_address ?? "");
      setBusinessFareEstimateParameters((prevState) => ({
        ...prevState,
        start_latitude: user?.address?.coordinates[1] ?? 0,
        start_longitude: user?.address?.coordinates[0] ?? 0,
        start_address: user.address?.formatted_address ?? "-/-",
        start_addressLine2: user.address?.addressLine2 ?? "-/-",
      }));
      // setOriginTemp(user.address.formatted_address ?? "");
    }
  }, [user]);

  useEffect(() => {
    // console.log("useEffect currentUser.id");
    setNewOrder((prevState) => ({ ...prevState, userID: currentUser ?? "" }));
  }, [currentUser]);

  // FARE
  const [fare, setFare] = useState<FareInterface>({
    estimatedPrice: 0,
    estimatedPriceExpress: 0,
    vehicleCategories: [],
  });
  const [businessFare, setBusinessFare] = useState<BusinessFareInterface>();
  const [businessFareEstimateParameters, setBusinessFareEstimateParameters] =
    useState<BusinessFareEstimateParametersInterface>({
      start_latitude: 0,
      start_longitude: 0,
      start_address: "-/-",
      start_addressLine2: "-/-",
      start_information: "-/-",

      end_latitude: 0,
      end_longitude: 0,
      end_address: "-/-",
      end_addressLine2: "-/-",
      end_information: "-/-",
    });
  const [businessFareEstimateMessage, setBusinessFareEstimateMessage] =
    useState<string>("");
  const [triedToCreateBusinessFare, setTriedToCreateBusinessFare] =
    useState<boolean>(false);
  const [origin, setOrigin] = useState("");
  const [creatingNewOrder, setCreatingNewOrder] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<AlertColor>("info");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [newOrder, setNewOrder] = useState<OrderInterface>({
    // id: "",
    exclusiveDelivery: false,
    convenienceRequired: false,
    vehicleCategory: 2,
    packDescription: "",
    price: 7.6,
    distance: 0,
    originAddress: {
      formatted_address: "",
      addressLine2: "-/-",
      information: "-/-",
    },
    toAddress: {
      formatted_address: "",
      addressLine2: "-/-",
      information: "-/-",
    },
    waypoints: [],
    status: "",
    userID: appContext?.userID ?? "", // PUXAR O ID LOCAL DO USUÁRIO JWT
    userType: "END_USER", //BUSINESS_USER OU END_USER
    originCoordinate: {
      type: "Point",
      coordinates: [0, 0],
    },
    destinationCoordinate: {
      type: "Point",
      coordinates: [0, 0],
    },
    recipientName: "",
    recipientPhone: "",
    deliveryForecastTime: moment().toISOString(),

    // Colunas em exclusão
    packUrgency: false,

    qrCodeReceiverNecessary: false,
    paymentMethod: "CASH",
    paymentOn: "PICKUP",
    scheduleTime: moment().toDate(),
    scheduleCollect: false,
  });

  const [originalPrice, setOriginalPrice] = useState<number>(0);

  const tryCreateNewOrder = async () => {
    setCreatingNewOrder(true);

    const request = functionsApiPublic.createBusinessOrderByCoverageAreaV3({
      fareID: businessFare?.fareID ?? undefined,
      recipientName: newOrder.recipientName ?? "-/-",
      vehicleCategory: 2,
      exclusiveDelivery: exclusiveDelivery,
      directDelivery: directDelivery,
      convenienceRequired: false,
      paymentMethod: "CASH",
      paymentOn: "PICKUP",
      qrCodeReceiverNecessary: false,
      scheduleCollect: false,
      packDescription: "Pedido Painel - Novo",
      packUrgency: false,
      price: selectedDestination?.price ?? 7.6,
      recipientPhone: newOrder.recipientPhone ?? "-/-",
      confirmationCode: "1234",
      callbackEndpoint: "https://www.google.com",
      distance: 1,
      origin: {
        coordinate: {
          coordinates: [
            newOrder.originCoordinate.coordinates[0],
            newOrder.originCoordinate.coordinates[1],
          ],
        },
        formattedAddress: newOrder.originAddress?.formatted_address ?? "", //formatted_address
        addressLine2: newOrder.originAddress?.addressLine2 ?? "",
        information: newOrder.originAddress?.information ?? "",
      },
      destination: {
        coverageAreaId: destination,
        formattedAddress: `${neighborhood}, ${number}, ${selectedDestination?.coverageArea.name}`,
        addressLine2: complement,
        street: neighborhood,
        number,
        complement,
        zipcode,
        information: newOrder.toAddress?.information ?? "",
      },
      deliveryManId: motoboy,
    });

    request
      .then((response) => {
        notyf.success("Pedido criado com sucesso!");
        setAlertType("success");
        setAlertTitle("Pedido criado com sucesso!");
        setAlertMessage(
          "Parabéns! Seu pedido foi criado com sucesso pelo Leve Aí - Parceiros. Veja o andamento do pedido no menu."
        );
        setCreatingNewOrder(false);
        history("/orders");
      })
      .catch((error) => {
        // console.log(error);
        if (JSON.stringify(error).includes("401")) {
          AuthService.Logout();
        }

        let alertTitle = "Erro ao criar o pedido!";
        let alertMessage =
          "Um erro ocorreu ao criar o seu pedido. Tente novamente mais tarde. Se o erro persistir, entre em contato com o suporte.";
        // MENSAGENS CUSTOMIZADAS DE ERRO
        if (
          error !== undefined &&
          error?.response !== undefined &&
          error?.response?.data !== undefined
        ) {
          if (error?.response?.data?.type === "INSUFFICIENT_PREPAID_BALANCE") {
            alertMessage =
              "Você não tem saldo suficiente para criar este pedido.";
          }
        }
        // console.log(error);
        notyf.error("Ocorreu um erro ao criar o pedido.");
        setAlertType("error");
        setAlertTitle(alertTitle);
        setAlertMessage(alertMessage);
        setCreatingNewOrder(false);
      });
  };

  useEffect(() => {
    const getFareData = () => {
      API_FARE.post("/business-fare", {
        destinationCoordinate: newOrder.destinationCoordinate,
        businessID: newOrder.userID,
      })
        .then((response) => {
          // console.log(response.data);
          setFare(response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTriedToCreateBusinessFare(false);
          setBusinessFare(undefined);
          setBusinessFareEstimateMessage("");
        });
    };

    if (newOrder.distance !== 0) {
      getFareData();
    }
  }, [
    newOrder.distance,
    newOrder.destinationCoordinate,
    newOrder.originCoordinate,
    newOrder.userID,
  ]);

  const fixCategoryPrice = useCallback(() => {
    let tempFare: FareInterface = { vehicleCategories: [] };
    if (fare !== undefined && fare !== null) {
      for (let i = 0; i < fare.vehicleCategories.length; i++) {
        // if ((fare.vehicleCategories[i].maxKM ?? 1) >= newOrder.distance){
        tempFare.vehicleCategories.push(fare.vehicleCategories[i]);
        // }
      }
      if (
        tempFare !== undefined &&
        tempFare.vehicleCategories !== undefined &&
        tempFare.vehicleCategories[0] !== undefined &&
        tempFare.vehicleCategories[0].type !== undefined
      ) {
        setNewOrder((prevState) => ({
          ...prevState,
          vehicleCategory: tempFare.vehicleCategories[0].type ?? 2,
          price:
            (newOrder.exclusiveDelivery
              ? tempFare.vehicleCategories[0].exclusivePrice
              : tempFare.vehicleCategories[0].sharedPrice) ?? 100,
          deliveryForecastTime: newOrder.exclusiveDelivery
            ? tempFare.vehicleCategories[0].exclusiveForecast
            : tempFare.vehicleCategories[0].sharedForecast,
        }));
        setOriginalPrice(
          (newOrder.exclusiveDelivery
            ? tempFare.vehicleCategories[0].exclusivePrice
            : tempFare.vehicleCategories[0].sharedPrice) ?? 100
        );
      }
    }
  }, [fare, newOrder.exclusiveDelivery]);

  useEffect(() => {
    fixCategoryPrice();
  }, [fixCategoryPrice]);

  useEffect(() => {
    setNewOrder((prevState) => ({
      ...prevState,
      userID: appContext?.userID ?? "",
    }));
  }, [appContext]);

  const getProfileAddress = useCallback(() => {
    UserService.getProfileAddress(currentUser ?? "")
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        if (JSON.stringify(error).includes("401")) {
          AuthService.Logout();
        }

        console.log(error);
      });
  }, [currentUser]);

  useEffect(() => {
    getProfileAddress();
  }, [getProfileAddress]);

  return (
    <>
      <Box m={2}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            Página inicial
          </Link>
          <Link underline="hover" color="inherit" href="/orders">
            Pedidos
          </Link>
          <Typography color="text.primary" aria-current="page">
            Novo pedido
          </Typography>
        </Breadcrumbs>
      </Box>
      <Box
        sx={{
          padding: {
            xs: 0,
            md: "32px",
            lg: "32px",
          },
        }}
      >
        <Box mb={3}>
          <div>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: { optional?: React.ReactNode } = {};
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div>
              {activeStep === steps.length ? (
                <div>
                  {creatingNewOrder ? (
                    <>
                      <Card>
                        <CardHeader title={"Criando novo pedido"} />
                        <CardContent>
                          <CircularProgress />
                        </CardContent>
                      </Card>
                    </>
                  ) : (
                    <>
                      <Card>
                        <CardHeader title={"Criando novo pedido"} />
                        <CardContent>
                          <Alert severity={alertType ?? "info"}>
                            <AlertTitle>{alertTitle}</AlertTitle>
                            {alertMessage}
                          </Alert>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </div>
              ) : (
                <div>
                  <Box>{getStepContent(activeStep)}</Box>

                  <div
                    style={{
                      marginBottom: 124,
                      paddingLeft: 16,
                      paddingRight: 16,
                    }}
                  >
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      style={{
                        display: activeStep === 0 ? "none" : "inline",
                        marginRight: activeStep === 0 ? 0 : 8,
                      }}
                    >
                      Voltar
                    </Button>
                    {activeStep === steps.length - 1 ? (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleNext();
                            tryCreateNewOrder();
                          }}
                          disabled={
                            newOrder.recipientName === "" ||
                            creatingNewOrder ||
                            isNaN(newOrder.price)
                          }
                        >
                          Finalizar
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          // disabled={
                          //   origin === "" ||
                          //   destination === "" ||
                          //   newOrder.distance === 0 ||
                          //   waypointInvalid() ||
                          //   triedToCreateBusinessFare === false
                          // }
                        >
                          Próximo
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default CreateOrderByCoverageArea;
